import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { Washer } from "../../../../http/screwConnector/types/washers";
import useScrewConnectorWashersApi from "../../../../http/screwConnector/useAdminWashers";
import WasherForm from "./WasherForm";

const AdminWashers: FC = () => {
  const i18n = useI18n();
  const t = i18n.translation.screwConnectorModule;
  const washersApi = useScrewConnectorWashersApi();

  return (
    <AdminCrudTable<Washer>
      filterPrefix="washers"
      useList={washersApi.useWashers}
      head={
        <>
          <TableHeadCell align="left">{t.washers.fields.code}</TableHeadCell>
          <TableHeadCell align="left">{t.washers.fields.innerDiameter}</TableHeadCell>
          <TableHeadCell align="left">{t.washers.fields.outerDiameter}</TableHeadCell>
          <TableHeadCell align="left">{t.washers.fields.height}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.code}</TableCell>
          <TableCell>
            {item.innerDiameter} {i18n.translation.common.unitMm}
          </TableCell>
          <TableCell>
            {item.outerDiameter} {i18n.translation.common.unitMm}
          </TableCell>
          <TableCell>
            {item.height} {i18n.translation.common.unitMm}
          </TableCell>
        </>
      )}
      onDelete={(item) => washersApi.deleteWasher(item.code)}
      deleteTitle={t.washers.singular}
      canAdd
      renderForm={(item, onClose) => <WasherForm washer={item} onClose={onClose} />}
    />
  );
};

export default AdminWashers;
